export default {
  "content": "<path d=\"M13 13.691l2.316-2.17 1.368 1.458-4 3.75a1 1 0 01-1.368 0l-4-3.75 1.368-1.458L11 13.69V8h2v5.691z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.5 6h-2v11.5a3 3 0 01-3 3h-11a3 3 0 01-3-3V6h-2V4h21v2zm-17 0v11.5a1 1 0 001 1h11a1 1 0 001-1V6h-13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};